{
  "viralRecording": {
    "status": {
      "loading": "Chargement...",
      "loadingProcessData": "Chargement des données du processus...",
      "loadingRecordingData": "Chargement des données d'enregistrement..."
    },
    "buttons": {
      "startRecording": "Démarrer l'enregistrement",
      "finishing": "Finalisation...",
      "finishRecording": "Terminer l'enregistrement",
      "save": "Enregistrer",
      "delete": "Supprimer",
      "addCondition": "Ajouter une condition",
      "addRule": "Ajouter une règle",
      "reorderRule": "Glisser pour réorganiser la règle",
      "back": "Retour",
      "addNewInput": "Ajouter une entrée",
      "seeMoreAndChange": "Voir plus et modifier",
      "createStartEvent": "Créer un événement de départ"
    },
    "labels": {
      "startEvent": "Événement de départ",
      "previousEvent": "Événement précédent",
      "noDescriptionAvailable": "Aucune description disponible",
      "rule": "Règle",
      "ruleNumber": "Règle {{number}}",
      "unclear": "Incertain",
      "none": "Aucun",
      "theProcessWillEndHere": "Le processus se termine ici.",
      "iReceive": "Je reçois",
      "iDo": "Je fais",
      "iUse": "J'utilise",
      "iCreate": "Je crée",
      "youLabel": "{{name}} (Vous)",
      "event": "Événement",
      "information": "Information",
      "untitled": "Sans titre",
      "processStepDescription": "Description de l'étape de processus",
      "processInformation": "Fournir le nom et la description du processus",
      "processDetailsOverview": "Aperçu des données de base de ce processus",
      "process": "Activité",
      "decision": "Décision",
      "defineOutput": "Définir la sortie",
      "unknownUser": "Utilisateur inconnu",
      "unknownRole": "Poste inconnu",
      "processName": "Nom du processus",
      "description": "Description",
      "organizationInfo": "Informations sur l'organisation",
      "owner": "Responsable du processus",
      "createdBy": "Créé par",
      "department": "Département",
      "timestamps": "Horodatages",
      "createdAt": "Créé le",
      "updatedAt": "Dernière mise à jour",
      "decisionRules": "Règles de décision",
      "clickToOpen": "Cliquer pour ouvrir le tableau de décision",
      "clickToEdit": "Cliquer pour modifier",
      "result": "Résultat",
      "outputHint": "Que se passe-t-il ensuite lorsque ces conditions s'appliquent ? Veuillez le formuler indépendamment de toute personne (Bon : « Processus de vente standard », « Processus de vente spécial ». Mauvais : « Transmettre à Pierre »)."
    },
    "placeholders": {
      "noInputsAddedYet": "Aucune entrée ajoutée pour le moment",
      "defineProcessStepDescription": "Définir la description de l'étape de processus...",
      "choose": "Choisir",
      "enterCondition": "p.ex. Valeur de commande > 100€",
      "enterConditionAlt": "p.ex. Valeur de commande < 100€",
      "enterCondition2": "p.ex. Type de client = Premium",
      "enterCondition2Alt": "p.ex. Type de client = Standard",
      "enterOutput": "p.ex. Approuver automatiquement",
      "enterOutput2": "p.ex. Demander l'approbation du responsable"
    },
    "sections": {
      "inputsReceived": "Événements et informations",
      "helpers": "Aides"
    },
    "modals": {
      "eventModal": {
        "editEventTitle": "Modifier l'événement de démarrage",
        "createEventTitle": "Créer un événement de démarrage",
        "startEventDescription": "Définir le déclencheur qui lance ce processus.",
        "type": "Type",
        "trigger": "Déclencheur",
        "eventName": "Nom de l'événement",
        "selectTrigger": "Sélectionner un déclencheur",
        "selectEventType": "Sélectionner le type d'événement",
        "enterEventName": "Saisir le nom de l'événement",
        "describeWhatTriggers": "Décrivez ce qui déclenche cet événement"
      },
      "decisionTable": {
        "title": "Tableau de décision",
        "descriptionNew": "Définissez les règles de décision à l'aide de conditions personnalisées. Chaque règle crée une carte de successeur.",
        "configureRulesDescription": "Configurer les règles de décision pour déterminer l'action suivante en fonction des conditions",
        "emptyCondition": "Condition vide",
        "validationMessageNew": "Chaque règle doit avoir au moins une condition remplie et une sortie",
        "successorReminder": "N'oubliez pas d'assigner des successeurs à chaque règle après avoir enregistré le tableau de décision",
        "defaultCondition": "Condition {{number}}",
        "editColumnName": "Cliquer pour modifier le nom de la colonne",
        "orSeparator": "ou"
      },
      "inputModal": {
        "editTitle": "Modifier l'entrée",
        "viewTitle": "Voir l'entrée",
        "addTitle": "Ajouter une entrée",
        "description": "Quels événements déclenchent cette étape ou ce qui est nécessaire pour effectuer l'étape. (ex. un rapport, des métriques, etc.)",
        "inputTypeSection": "Type d'entrée",
        "eventDetails": "Détails de l'événement",
        "informationDetails": "Détails de l'information",
        "inputTypeEvent": "Événement",
        "inputTypePreviousOutput": "Information (De l'étape précédente)",
        "informationName": "Nom de l'information",
        "enterInformationName": "ex. Coordonnées du client",
        "describeInformation": "Décrivez le contenu de cette information",
        "linkToProcessStep": "Lier à une étape du processus",
        "linkToProcessStepHint": "Choisissez les étapes dont le résultat doit être disponible avant que cette étape puisse démarrer.",
        "selectProcessStep": "Rechercher une étape...",
        "noCompletedSteps": "Aucune étape terminée disponible",
        "allStepsAlreadyLinked": "Toutes les étapes disponibles sont déjà liées",
        "outputLabel": "Sortie : {{output}}",
        "linkedStepNotFound": "Étape liée n'est plus disponible",
        "inputType": "Type",
        "selectInputType": "Sélectionner le type d'entrée"
      }
    },
    "helpersHeading": {
      "systems_one": "1 système",
      "systems_other": "{{count}} systèmes",
      "participants_one": "1 participant",
      "participants_other": "{{count}} participants",
      "colleagues_one": "1 collègue",
      "colleagues_other": "{{count}} collègues",
      "documents_one": "1 document",
      "documents_other": "{{count}} documents",
      "addHint": "Ajouter",
      "pendingSystem": "Système suggéré",
      "pendingFunction": "Équipe ou fonction suggérée"
    },
    "tooltips": {
      "input": "Ajoutez ici tout ce qui entre et dont vous avez besoin pour réaliser l'étape du processus : un événement qui déclenche l'étape (p. ex. une réunion trimestrielle) ou une information que vous traitez (p. ex. un rapport ou un indicateur). Les ouvrages de référence comme les directives relèvent plutôt des « Documents ».",
      "actionType": "Décrivez ce qui se passe dans cette étape. S'il s'agit d'une activité normale, choisissez « Activité ». Si la suite dépend de conditions (p. ex. approuvé/refusé), choisissez « Décision ».",
      "helpers": "Avec quoi et avec qui réalisez-vous cette étape ? Systèmes utilisés, personnes obligatoirement impliquées et documents nécessaires.",
      "documents": "Les documents servent uniquement de référence – directives, listes de contrôle, modèles. Ils restent inchangés. En revanche, ce que vous traitez et transmettez relève de l'« Information » dans l'entrée."
    }
  },
  "entityPicker": {
    "common": {
      "allFacet": "Tous",
      "noResults": "Aucun résultat",
      "recommendedBadge": "RECOMMANDÉ",
      "matchInFieldTemplate": "— Trouvé dans {{field}}",
      "statsLine": "dans {{occurrences}} de {{samples}} enregistrements ({{percent}} %)",
      "departmentFilterAll": "Tous les départements",
      "departmentFilterAriaLabel": "Filtrer par département",
      "departmentFilterPrefix": "Département :",
      "fields": {
        "email": "E-mail",
        "description": "Description",
        "role": "Poste",
        "department": "Département",
        "category": "Catégorie",
        "type": "Type",
        "name": "Nom"
      },
      "buckets": {
        "recentlyUsed": "Récemment utilisés par vous",
        "recentlyUsedSubtitle_one": "d'après votre dernier enregistrement",
        "recentlyUsedSubtitle_other": "d'après vos {{count}} derniers enregistrements",
        "selected": "Sélectionnés ({{count}})",
        "pendingSuggestions": "Suggestions en attente"
      },
      "selectedSectionLabel_one": "Sélectionné ({{count}})",
      "selectedSectionLabel_other": "Sélectionnés ({{count}})",
      "removeChipAriaLabel": "Retirer {{name}}",
      "switchToAllLabel": "Afficher les {{count}}",
      "switchToBucketsLabel": "Afficher les suggestions",
      "allGroupSelectedLabel": "Sélectionnés ({{count}})"
    },
    "system": {
      "title": "Choisir des systèmes",
      "description": "Quels systèmes utilisez-vous dans cette étape ? Sélection multiple.",
      "searchPlaceholder": "Nom du système, fournisseur ou catégorie",
      "empty": "Aucun système correspondant",
      "saveSingular": "Enregistrer (1 système)",
      "savePlural": "Enregistrer ({{count}} systèmes)",
      "saveZero": "Enregistrer",
      "requestNewTitle": "Demander un nouveau système",
      "requestNewDescription": "Un administrateur examinera et l'ajoutera au catalogue.",
      "allGroupRestLabel": "Autres systèmes ({{count}})",
      "showAllCtaTitle": "Parcourir tous les systèmes",
      "showAllCtaMeta": "{{count}} systèmes · filtrable par catégorie",
      "suggestRowTitle": "Système absent ?",
      "suggestRowMeta": "Proposer un nouveau système pour la bibliothèque.",
      "emptyStateCtaWithQuery": "Proposer « {{query}} » comme nouveau système",
      "emptyStateCtaBlank": "Proposer un nouveau système",
      "createRowMeta": "Créez un nouveau système.",
      "createCtaWithQuery": "Créer « {{query}} » comme nouveau système",
      "createCtaBlank": "Créer un nouveau système",
      "buckets": {
        "recentlyUsed": "Récemment utilisés par vous",
        "recentlyUsedSubtitle_one": "d'après votre dernier enregistrement",
        "recentlyUsedSubtitle_other": "d'après vos {{count}} derniers enregistrements",
        "byRole": "Courant dans votre poste",
        "byRolePeerCount": "{{count}} collègues avec le même poste",
        "byProcess": "Pour ce processus",
        "byProcessSampleSize": "à partir de {{count}} enregistrements similaires",
        "byDepartment": "Courant dans votre département",
        "byDepartmentPeerCount": "{{count}} collègues dans votre département",
        "annotation": {
          "recentlyUsed": "utilisé par vous récemment",
          "byRole": "{{count}} collègues l'utilisent",
          "byProcess": "dans {{count}} enregistrements similaires",
          "byDepartment": "{{count}} collègues de votre département l'utilisent"
        }
      },
      "resultCount_one": "{{count}} résultat",
      "resultCount_other": "{{count}} résultats",
      "helperAvailableAsSuccessor": "Précédemment proposé comme support"
    },
    "user": {
      "title": "Choisir les participants",
      "description": "Choisissez les personnes qui contribuent activement à cette étape, par exemple pour une validation à quatre yeux ou un traitement conjoint. Plusieurs possibles.",
      "searchPlaceholder": "Nom, poste, département ou e-mail",
      "empty": "Aucun collègue correspondant",
      "saveSingular": "Enregistrer (1 collègue)",
      "savePlural": "Enregistrer ({{count}} collègues)",
      "saveZero": "Enregistrer",
      "allGroupRestLabel": "Autres collègues ({{count}})",
      "showAllCtaTitle": "Parcourir tous les collègues",
      "showAllCtaMeta": "{{count}} collègues · filtrable par département",
      "buckets": {
        "byRole": "Courant dans votre poste",
        "byDepartment": "Courant dans votre département",
        "byProcess": "Fréquent pour cette étape"
      }
    },
    "helper": {
      "title": "Choisir des personnes ou des fonctions",
      "description": "Choisissez qui contribue activement à cette étape : des personnes, ou une équipe ou une fonction entière. Plusieurs possibles.",
      "saveSingular": "Enregistrer (1 participant)",
      "savePlural": "Enregistrer ({{count}} participants)",
      "kind": {
        "person": "Personnes",
        "team": "Équipes",
        "role": "Fonctions"
      }
    },
    "artifact": {
      "title": "Choisir un document",
      "description": "Quel document utilisez-vous dans cette étape ? Par exemple une directive ou une liste de contrôle.",
      "searchPlaceholder": "Recherche par nom, description, type et tags",
      "empty": "Aucun document correspondant",
      "noDataTitle": "Aucun document pour le moment",
      "noDataMessage": "Créez votre premier document pour pouvoir le rattacher à des étapes de processus.",
      "saveSingular": "Enregistrer (1 document)",
      "savePlural": "Enregistrer ({{count}} documents)",
      "saveZero": "Enregistrer",
      "allGroupRestLabel": "Autres documents ({{count}})",
      "showAllCtaTitle": "Parcourir tous les documents",
      "showAllCtaMeta": "{{count}} documents · filtrable par type",
      "suggestRowTitle": "Document introuvable ?",
      "suggestRowMeta": "Créez un nouveau document dans la bibliothèque",
      "emptyStateCtaWithQuery": "Créer « {{query}} » comme nouveau document",
      "emptyStateCtaBlank": "Document introuvable ? En créer un",
      "buckets": {
        "byProcess": "Fréquent pour cette étape",
        "byType": "Documents typiques de type {{type}}"
      }
    },
    "orgFunction": {
      "buckets": {
        "byDepartment": "Courant dans votre département",
        "byProcess": "Fréquent pour cette étape"
      },
      "helperAvailableAsSuccessor": "Précédemment proposé pour cette étape"
    },
    "team": {
      "title": "Choisir une équipe",
      "description": "Quelle équipe prendra en charge l'étape suivante ?",
      "searchPlaceholder": "Nom, département ou e-mail",
      "empty": "Aucune équipe correspondante",
      "saveSingular": "Enregistrer (1 équipe)",
      "savePlural": "Enregistrer ({{count}} équipes)",
      "saveZero": "Enregistrer",
      "allGroupRestLabel": "Autres équipes ({{count}})",
      "showAllCtaTitle": "Parcourir toutes les équipes",
      "showAllCtaMeta": "{{count}} équipes · filtrable par département",
      "suggestRowTitle": "Équipe manquante ?",
      "suggestRowMeta": "Proposer une nouvelle équipe pour la bibliothèque.",
      "emptyStateCtaWithQuery": "Proposer « {{query}} » comme nouvelle équipe",
      "emptyStateCtaBlank": "Proposer une nouvelle équipe",
      "createRowMeta": "Créez une nouvelle équipe.",
      "createCtaWithQuery": "Créer « {{query}} » comme nouvelle équipe",
      "createCtaBlank": "Créer une nouvelle équipe"
    },
    "role": {
      "title": "Choisir une fonction",
      "description": "Quelle fonction prendra en charge l'étape suivante ?",
      "searchPlaceholder": "Nom, mandat, département ou e-mail",
      "empty": "Aucune fonction correspondante",
      "saveSingular": "Enregistrer (1 fonction)",
      "savePlural": "Enregistrer ({{count}} fonctions)",
      "saveZero": "Enregistrer",
      "allGroupRestLabel": "Autres fonctions ({{count}})",
      "showAllCtaTitle": "Parcourir toutes les fonctions",
      "showAllCtaMeta": "{{count}} fonctions · filtrable par département",
      "suggestRowTitle": "Fonction manquante ?",
      "suggestRowMeta": "Proposer une nouvelle fonction pour la bibliothèque.",
      "emptyStateCtaWithQuery": "Proposer « {{query}} » comme nouvelle fonction",
      "emptyStateCtaBlank": "Proposer une nouvelle fonction",
      "createRowMeta": "Créez une nouvelle fonction.",
      "createCtaWithQuery": "Créer « {{query}} » comme nouvelle fonction",
      "createCtaBlank": "Créer une nouvelle fonction"
    },
    "externalContact": {
      "title": "Choisir un contact externe",
      "description": "À quel contact externe le processus sera-t-il transmis ?",
      "searchPlaceholder": "Nom, organisation, type, e-mail ou description",
      "empty": "Aucun contact correspondant",
      "noDataTitle": "Aucun contact externe pour le moment",
      "noDataMessage": "Ajoutez un premier contact (client, fournisseur, partenaire…) pour pouvoir l'utiliser dans des étapes de processus.",
      "saveSingular": "Enregistrer (1 contact)",
      "savePlural": "Enregistrer ({{count}} contacts)",
      "saveZero": "Enregistrer",
      "allGroupRestLabel": "Autres contacts ({{count}})",
      "showAllCtaTitle": "Parcourir tous les contacts",
      "showAllCtaMeta": "{{count}} contacts · filtrable par type",
      "suggestRowTitle": "Contact absent ?",
      "suggestRowMeta": "Ajouter un nouveau contact externe.",
      "emptyStateCtaWithQuery": "Ajouter « {{query}} » comme nouveau contact",
      "emptyStateCtaBlank": "Contact absent ? L'ajouter",
      "buckets": {
        "byProcess": "Fréquent pour cette étape",
        "byType": "Contacts typiques de type {{type}}"
      }
    },
    "successor": {
      "title": "Prochain responsable",
      "breadcrumbAfter": "↳ Après « {{stepName}} » · Étape {{stepNumber}}",
      "descriptionCollapsed": "Qui ou quoi prend en charge l'étape suivante ?",
      "descriptionExpanded": "Faire un choix ou changer de type.",
      "sectionWhoOrWhat": "Qui ou quoi prend la suite ?",
      "sectionNotYetDefined": "Pas encore défini",
      "sidebarTypeHeading": "Type",
      "statusReadyToSave": "Prêt à enregistrer.",
      "statusPickToContinue": "Choisissez une option pour continuer.",
      "saveError": "Impossible d'enregistrer le successeur. Veuillez réessayer.",
      "ctaConfirmEntity": "Enregistrer",
      "type": {
        "person": {
          "sublabel": "Un employé"
        },
        "team": {
          "sublabel": "Une équipe de l'organisation"
        },
        "role": {
          "sublabel": "Une fonction de l'organisation"
        },
        "system": {
          "sublabel": "Étape automatisée"
        },
        "externalContact": {
          "sublabel": "Client, partenaire, administration"
        },
        "unclear": {
          "sublabel": "Le propriétaire du processus décidera plus tard"
        },
        "none": {
          "sublabel": "Le processus se termine ici"
        }
      },
      "unclear": {
        "cardTitle": "Indéfini — décider plus tard",
        "cardBody": "Marquer l'étape comme incertaine. Le propriétaire du processus est notifié à la fin de l'enregistrement et décide alors qui prend en charge l'étape suivante.",
        "willBeNotified": "SERA NOTIFIÉ",
        "ctaConfirm": "Marquer comme ouvert"
      },
      "none": {
        "cardTitle": "Aucun successeur",
        "cardBody": "(Fin du processus)",
        "warning": "Assurez-vous qu'aucune sortie vers une étape ultérieure n'est attendue.",
        "ctaConfirm": "Terminer le processus"
      }
    },
    "assignee": {
      "title": "Assigner l'étape",
      "descriptionCollapsed": "Qui ou quoi exécute cette étape du processus ?",
      "descriptionExpanded": "Faites un choix ou changez de type."
    },
    "starter": {
      "title": "Ajouter un initiateur du processus",
      "descriptionCollapsed": "Qui ou quoi démarre ce processus ?",
      "descriptionExpanded": "Faites un choix ou changez de type."
    },
    "reassign": {
      "title": "Prochain responsable",
      "descriptionCollapsed": "Qui ou quoi prend en charge la prochaine étape du processus ?",
      "descriptionExpanded": "Faites un choix ou changez de type."
    }
  },
  "recording": {
    "finishDisabled": {
      "title": "Impossible de terminer pour l'instant :",
      "missingActionType": "Choisis ce que fait cette étape (tâche ou décision)",
      "missingInput": "Ajoute au moins une entrée",
      "missingTaskDescription": "Décris ce que tu fais dans cette étape",
      "missingSuccessor": "Choisis qui ou ce qui vient ensuite",
      "missingOutput": "Définis la sortie de cette étape",
      "missingDecisionRule": "Complète les règles de décision"
    },
    "startDisabled": {
      "title": "Impossible de démarrer pour l'instant :",
      "missingStartEvent": "Configure l'événement de départ",
      "missingSuccessor": "Choisis qui ou ce qui vient ensuite"
    }
  }
}
